import { FillInBlankContent } from '@/resource/question/question.type';

const fillInBlankExample = new FillInBlankContent([
  'This is first item in fill in blank. ##answer##',
  'Second question with ##answer## here',
  'This ##answer## might be correct',
]);

export default fillInBlankExample;
